import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import API_CONFIG from '../config/api';
import Sidebar from '../Sidebar';

const GerenciarLicensa = ({ onLogout }) => {
  const navigate = useNavigate();
  const [licenseKey, setLicenseKey] = useState('');
  const [licenseKeyEditando, setLicenseKeyEditando] = useState('');
  const [loadingLicense, setLoadingLicense] = useState(false);
  const [licenseEditMode, setLicenseEditMode] = useState(false);
  const [message, setMessage] = useState(null);
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Verificar autenticação e permissão - apenas super admin
    const userData = localStorage.getItem('user');
    const parsedUser = userData ? JSON.parse(userData) : null;
    
    if (!parsedUser || parsedUser.tipo !== 'super_admin') {
      window.location.href = '/dashboard';
      return;
    }
    
    setUser(parsedUser);
    carregarLicensa();
  }, []);

  const carregarLicensa = async () => {
    setLoadingLicense(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API_CONFIG.API_URL}/jxbrowser-license`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.data.success) {
        setLicenseKey(response.data.licenseKey);
        setLicenseKeyEditando(response.data.licenseKey);
      }
    } catch (error) {
      console.error('Erro ao carregar licença:', error);
      setMessage({ type: 'error', text: 'Erro ao carregar chave de licença' });
    } finally {
      setLoadingLicense(false);
    }
  };

  const atualizarLicensa = async () => {
    if (!licenseKeyEditando.trim()) {
      setMessage({ type: 'error', text: 'A chave de licença não pode ser vazia' });
      return;
    }

    setLoadingLicense(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.put(
        `${API_CONFIG.API_URL}/jxbrowser-license`,
        { licenseKey: licenseKeyEditando.trim() },
        { headers: { 'Authorization': `Bearer ${token}` } }
      );

      if (response.data.success) {
        setLicenseKey(response.data.licenseKey);
        setLicenseEditMode(false);
        setMessage({ type: 'success', text: 'Chave de licença atualizada com sucesso!' });
        setTimeout(() => setMessage(null), 3000);
      }
    } catch (error) {
      console.error('Erro ao atualizar licença:', error);
      const errorMsg = error.response?.data?.message || 'Erro ao atualizar chave de licença';
      setMessage({ type: 'error', text: errorMsg });
    } finally {
      setLoadingLicense(false);
    }
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      <Sidebar user={user} onLogout={onLogout} />
      
      <div style={{ flex: 1, background: '#f5f5f5', padding: '2rem' }}>
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          {/* Header */}
          <div style={{ marginBottom: '2rem' }}>
            <button
              onClick={() => navigate('/admin/lojas')}
              style={{
                background: 'none',
                border: 'none',
                color: '#667eea',
                cursor: 'pointer',
                fontSize: '14px',
                marginBottom: '1rem',
                display: 'flex',
                alignItems: 'center',
                gap: '5px'
              }}
            >
              ← Voltar para Lojas
            </button>
            <h1 style={{ color: '#333', marginBottom: '0.5rem' }}>Gerenciar Licensa JxBrowser</h1>
            <p style={{ color: '#666', margin: 0 }}>
              Configure a chave de licença do JxBrowser para outros sistemas
            </p>
          </div>

          {/* Mensagem de Status */}
          {message && (
            <div style={{
              padding: '1rem',
              marginBottom: '2rem',
              borderRadius: '8px',
              background: message.type === 'success' ? '#d4edda' : '#f8d7da',
              border: `1px solid ${message.type === 'success' ? '#4caf50' : '#f5c2c7'}`,
              color: message.type === 'success' ? '#155724' : '#721c24'
            }}>
              {message.text}
            </div>
          )}

          {/* Card de Licensa */}
          <div style={{
            background: 'white',
            borderRadius: '12px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            padding: '2rem'
          }}>
            <h2 style={{ color: '#333', marginTop: 0, marginBottom: '1.5rem' }}>Chave de Licensa</h2>

            {loadingLicense && !licenseKey ? (
              <div style={{
                textAlign: 'center',
                padding: '3rem',
                color: '#999'
              }}>
                ⏳ Carregando chave de licença...
              </div>
            ) : (
              <div>
                {!licenseEditMode ? (
                  <div>
                    <div style={{ marginBottom: '1.5rem' }}>
                      <label style={{
                        display: 'block',
                        marginBottom: '0.75rem',
                        fontWeight: '500',
                        color: '#333',
                        fontSize: '14px'
                      }}>
                        Chave Atual
                      </label>
                      <div style={{
                        padding: '1.25rem',
                        background: '#f8f9fa',
                        border: '1px solid #ddd',
                        borderRadius: '8px',
                        fontFamily: 'monospace',
                        fontSize: '13px',
                        color: '#333',
                        wordBreak: 'break-all',
                        maxHeight: '150px',
                        overflowY: 'auto'
                      }}>
                        {licenseKey || 'Nenhuma chave configurada'}
                      </div>
                    </div>

                    <button
                      onClick={() => {
                        setLicenseEditMode(true);
                        setLicenseKeyEditando(licenseKey);
                      }}
                      style={{
                        padding: '10px 24px',
                        background: '#667eea',
                        color: 'white',
                        border: 'none',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: '500',
                        transition: 'background 0.3s'
                      }}
                      onMouseEnter={(e) => e.target.style.background = '#5568d3'}
                      onMouseLeave={(e) => e.target.style.background = '#667eea'}
                    >
                      ✏️ Editar Chave
                    </button>
                  </div>
                ) : (
                  <div>
                    <label style={{
                      display: 'block',
                      marginBottom: '0.75rem',
                      fontWeight: '500',
                      color: '#333',
                      fontSize: '14px'
                    }}>
                      Nova Chave de Licensa
                    </label>
                    <textarea
                      value={licenseKeyEditando}
                      onChange={(e) => setLicenseKeyEditando(e.target.value)}
                      style={{
                        width: '100%',
                        padding: '1rem',
                        border: '1px solid #ddd',
                        borderRadius: '8px',
                        fontFamily: 'monospace',
                        fontSize: '13px',
                        minHeight: '150px',
                        resize: 'vertical',
                        outline: 'none',
                        boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.05)',
                        boxSizing: 'border-box'
                      }}
                      placeholder="Cole a nova chave de licensa aqui"
                    />
                    
                    <div style={{ marginTop: '1.5rem', display: 'flex', gap: '1rem' }}>
                      <button
                        onClick={atualizarLicensa}
                        disabled={loadingLicense}
                        style={{
                          padding: '10px 24px',
                          background: loadingLicense ? '#95a5a6' : '#27ae60',
                          color: 'white',
                          border: 'none',
                          borderRadius: '8px',
                          cursor: loadingLicense ? 'not-allowed' : 'pointer',
                          fontSize: '14px',
                          fontWeight: '500',
                          transition: 'background 0.3s'
                        }}
                        onMouseEnter={(e) => !loadingLicense && (e.target.style.background = '#229954')}
                        onMouseLeave={(e) => !loadingLicense && (e.target.style.background = '#27ae60')}
                      >
                        {loadingLicense ? '⏳ Salvando...' : '💾 Salvar Chave'}
                      </button>
                      <button
                        onClick={() => {
                          setLicenseEditMode(false);
                          setLicenseKeyEditando(licenseKey);
                        }}
                        disabled={loadingLicense}
                        style={{
                          padding: '10px 24px',
                          background: '#e0e0e0',
                          color: '#333',
                          border: 'none',
                          borderRadius: '8px',
                          cursor: loadingLicense ? 'not-allowed' : 'pointer',
                          fontSize: '14px',
                          fontWeight: '500',
                          transition: 'background 0.3s'
                        }}
                        onMouseEnter={(e) => !loadingLicense && (e.target.style.background = '#d0d0d0')}
                        onMouseLeave={(e) => !loadingLicense && (e.target.style.background = '#e0e0e0')}
                      >
                        ✖️ Cancelar
                      </button>
                    </div>
                  </div>
                )}

                {/* Info Box */}
                <div style={{
                  marginTop: '2rem',
                  padding: '1.25rem',
                  background: '#e8f5e9',
                  border: '1px solid #4caf50',
                  borderRadius: '8px',
                  color: '#2e7d32',
                  fontSize: '13px',
                  lineHeight: '1.6'
                }}>
                  <strong>ℹ️ Informações importantes:</strong>
                  <ul style={{ marginTop: '0.75rem', paddingLeft: '1.5rem', margin: '0.75rem 0 0 0' }}>
                    <li>Esta chave é consumida por outros sistemas via API pública</li>
                    <li>Apenas usuários super admin podem atualizar esta chave</li>
                    <li>Alterações entram em efeito imediatamente</li>
                    <li>Usuários inativos não conseguem acessar a chave via API</li>
                  </ul>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GerenciarLicensa;
